
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import {
  addProjectQuestion,
  addResource,
  delResource,
  editUser,
  getProjectDetail,
  getProjectQuestionList,
  getProjectTaskCollectDetail,
  getProjectTaskDetail,
  getProjectTaskProgressList,
} from "@/api/project";
import { parseTime } from "@/utils";
import { makeKey } from "@/utils/qiniu";
import { Qiniu } from "@/types/qiniu";
import { getQiniuToken } from "@/api/third";
import DialogImgLarge from "@/components/ImgLarge/index.vue";
import DialogSetStaff from "../../staff/components/setStaff.vue";

@Component({
  name: "setShifts",
  components: {
    DialogImgLarge,
    DialogSetStaff,
  },
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  dialogProjectDetailsVisible!: Boolean;
  @Prop({
    type: Object,
    default: () => {},
  })
  projectItem!: any;

  private projectAlias = UserModule.getCompany.project_alias
    ? UserModule.getCompany.project_alias
    : "项目";
  private projectTaskAlias = UserModule.getCompany.project_task_alias
    ? UserModule.getCompany.project_task_alias
    : "任务";
  private projectTaskCollectAlias = UserModule.getCompany
    .project_task_collect_alias
    ? UserModule.getCompany.project_task_collect_alias
    : "任务集";
  private activeName = "basic";
  private projectDetailsTitle = this.projectAlias + "详情";
  private detailData: any = {};
  private type: number = 1;

  private qiuniuToken: any = {
    action_url: "",
  };
  private qiuniuform = {};
  private formProject: any = {
    fileListAdd: [],
  };
  private formQustAdd: any = {
    describe: "",
    picQustList: [],
    videoQustList: []
  };
  private dialogQustAddVisible = false;
  private defaultImgUrl =
    'this.src="' + require("@/assets/images/default-avatar.png") + '"';

  private getDeferred(detail: any, type: number) {
    let str = "";
    if (type === 1) {
      if (parseInt(detail.state) === 0) {
        str = "未开始";
        if (
          parseInt(detail.plan_start_date_time) <
          parseInt(Date.now() / 1000 + "")
        ) {
          str = str + "(延期)";
        }
      } else {
        if (parseInt(detail.real_start_date_time) !== 0) {
          str = parseTime(detail.real_start_date_time, "{y}-{m}-{d}") + "";
        } else {
          str = "暂无";
        }
        if (parseInt(detail.real_start_date_time) !== 0) {
          if (detail.plan_start_date_time < detail.real_start_date_time) {
            str = str + "（延期）";
          } else {
            str = str + "（正常）";
          }
        }
      }
    }
    if (type === 2) {
      if (parseInt(detail.state) !== 2) {
        str = "未结束";
        if (
          parseInt(detail.plan_end_date_time) < parseInt(Date.now() / 1000 + "")
        ) {
          str = str + "(延期)";
        }
      } else {
        if (parseInt(detail.real_end_date_time) !== 0) {
          str = parseTime(detail.real_end_date_time, "{y}-{m}-{d}") + "";
        } else {
          str = "暂无";
        }
        if (parseInt(detail.real_end_date_time) !== 0) {
          if (detail.plan_end_date_time < detail.real_end_date_time) {
            str = str + "（延期）";
          } else {
            str = str + "（正常）";
          }
        }
      }
    }
    return str;
  }

  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_PROJECT,
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiuniuToken = res.data;
      }
    });
    if (this.projectItem && parseInt(this.projectItem.is_project) === 1) {
      this.projectDetailsTitle = this.projectAlias + "详情";
      this.type = 1;
      this.getProjectDetail();
    } else if (parseInt(this.projectItem.is_task_collect) === 1) {
      this.projectDetailsTitle = this.projectTaskCollectAlias + "详情";
      this.type = 2;
      this.getProjectTaskCollectDetail();
    } else {
      this.type = 3;
      this.projectDetailsTitle = this.projectTaskAlias + "详情";
      this.getProjectTaskDetail();
    }
  }
  private getProjectDetail() {
    let _ = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = this.projectItem.id;
    getProjectDetail(pamars).then((res: any) => {
      _.detailData = res.data;
      _.detailData.relation_names = _.getMagangerNames(
        _.detailData.relation_user_list
      );
      if (parseInt(_.detailData.no_solve_problem_number) > 0) {
        this.getQust();
      }
    });
  }
  private getProjectTaskCollectDetail() {
    let _ = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = this.projectItem.project_id;
    pamars.project_task_id = this.projectItem.id;
    getProjectTaskCollectDetail(pamars).then((res: any) => {
      _.detailData = res.data;
      _.detailData.manager_names = _.getMagangerNames(_.detailData.user_list);
      if (parseInt(_.detailData.no_solve_problem_number) > 0) {
        this.getQust();
      }
    });
  }
  private getProjectTaskDetail() {
    let _ = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = this.projectItem.project_id;
    pamars.project_task_id = this.projectItem.id;
    getProjectTaskDetail(pamars).then((res: any) => {
      _.detailData = res.data;
      _.detailData.manager_names = _.getMagangerNames(_.detailData.user_list);
      if (parseInt(_.detailData.no_solve_problem_number) > 0) {
        this.getQust();
      }
      this.projectTaskProgressList()
    });
  }

  private getMagangerNames(val: any) {
    var managerNames = "";
    if (val) {
      for (var i = 0; i < val.length; i++) {
        if (i === val.length - 1) {
          managerNames += val[i].user_name;
        } else {
          managerNames += val[i].user_name + ",";
        }
      }
    }
    return managerNames;
  }

  private close() {
    this.$emit("close", false);
  }

  private uploadSuccess(res: any, file: any) {
    (this.$refs.uploadResource as any).clearFiles();
    let fileList: any = [];
    let fileData: any = {};
    fileData.name = file.raw.name;
    fileData.content = file.response.key;
    if (file.raw.type.includes("image")) {
      fileData.type = 1;
      fileList.push(fileData);
    } else if (file.raw.type.includes("video")) {
      fileData.type = 3;
      fileList.push(fileData);
    } else {
      fileData.type = 4;
      fileList.push(fileData);
    }
    let pamars: any = {};
    pamars.user_name = UserModule.getUserName;
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.resources = JSON.stringify(fileList);
    if (this.projectItem.is_project) {
      pamars.project_id = this.detailData.id;
    } else {
      pamars.project_id = this.detailData.project_id;
      pamars.project_task_id = this.detailData.id;
    }
    addResource(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        if (this.projectItem && parseInt(this.projectItem.is_project) === 1) {
          this.getProjectDetail();
        } else if (parseInt(this.projectItem.is_task_collect) === 1) {
          this.getProjectTaskCollectDetail();
        } else {
          this.getProjectTaskDetail();
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private beforeUpload(file: any) {
    // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    // const isLt2M = file.size / 1024 / 1024 < 5;
    // if (!isJPG) {
    //   return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    // }
    // if (!isLt2M) {
    //   return this.$message.error('上传图片大小不能超过 5MB!');
    // }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiuniuToken.prekey);
      if (file.type === "video/mp4") {
        k = k + ".mp4";
      }
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain,
      };
    });
  }
  private uploadSuccessQust(res: any, file: any) {
    let fileData: any = {};
    fileData.name = file.raw.name;
    fileData.content = file.response.key;
    if (file.raw.type.includes("image")) {
      fileData.type = 1;
      this.formQustAdd.picQustList.push(fileData)
    } else if (file.raw.type.includes("video")) {
      fileData.type = 3;
      this.formQustAdd.videoQustList.push(fileData);
    }
  }
  private beforeUploadQust(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiuniuToken.prekey);
      if (file.type === "video/mp4") {
        k = k + ".mp4";
      }
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain,
      };
    });
  }
  private beforeUploadQustV(file: any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiuniuToken.prekey);
      k = k + ".mp4";
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain,
      };
    });
  }
  private deleteImgHandle(val:any, num:number) {
    // 1 pic 2 sound 3 video
    switch (num) {
      case 1:
        for (let i = 0; i < this.formQustAdd.picQustList.length; i++) {
          if (this.formQustAdd.picQustList[i].content === val) {
            this.formQustAdd.picQustList.splice(i, 1);
          }
        }
        break;

      case 3:
        for (let n = 0; n < this.formQustAdd.videoQustList.length; n++) {
          if (this.formQustAdd.videoQustList[n].content === val) {
            this.formQustAdd.videoQustList.splice(n, 1);
          }
        }
        break;
    }
  }
  private addQustHandle() {
    this.dialogQustAddVisible = true;
    this.formQustAdd = {
      describe: "",
      picQustList: [],
      videoQustList: []
    };
  }
  private addQust() {
    if (!this.formQustAdd.describe) {
      this.showErrorMsg('请输入问题描述');
      return
    }
    let pamars: any = {};
    pamars.user_name = UserModule.getUserName;
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = this.detailData.project_id;
    pamars.project_task_id = this.detailData.id;
    pamars.describe = this.formQustAdd.describe;
    if (this.formQustAdd.picQustList && this.formQustAdd.picQustList.length > 0) {
      pamars.images = JSON.stringify(this.formQustAdd.picQustList);
    }
    if (this.formQustAdd.videoQustList && this.formQustAdd.videoQustList.length > 0) {
      pamars.videos = JSON.stringify(this.formQustAdd.videoQustList);
    }
    addProjectQuestion(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.dialogQustAddVisible = false;
        this.getQust()
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private resourceClick(val: any) {
    // val.type  图片 1  视频 3
    const url = val.url;
    const filename = val.name;
    let arr = ["pdf", "html"];
    let nameArr = filename.split(".");
    if (parseInt(val.type) === 1 || parseInt(val.type) === 3) {
      let arr = this.detailData.resources_list.filter((res: any) => {
        return parseInt(res.type) === 1 || parseInt(res.type) === 3;
      });
      let index = 0;
      let imgList: any = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].url === val.url) {
          index = i;
        }
        if (parseInt(arr[i].type) === 3) {
          let h: any = {};
          h.media_type = 2;
          h.video_url = arr[i].url;
          imgList.push(h);
        } else {
          imgList.push(arr[i].url);
        }
      }

      let enlargedData = {
        isShow: true,
        imgList: imgList,
        initNum: index,
      };
      this.$store.dispatch("toggleEnlarged", enlargedData);
    } else if (arr.includes(nameArr[1])) {
      window.open(url);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  }
  private closeFileHandle(val: any) {
    this.$confirm("是否删除?", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.delResouce(val);
      })
      .catch(() => {});
  }
  private delResouce(val: any) {
    let pamars: any = {};
    pamars.user_name = UserModule.getUserName;
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.resource_ids = val.id;
    if (this.projectItem.is_project) {
      pamars.project_id = this.detailData.id;
    } else {
      pamars.project_id = this.detailData.project_id;
      pamars.project_task_id = this.detailData.id;
    }
    delResource(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        if (this.projectItem && parseInt(this.projectItem.is_project) === 1) {
          this.getProjectDetail();
        } else if (parseInt(this.projectItem.is_task_collect) === 1) {
          this.getProjectTaskCollectDetail();
        } else {
          this.getProjectTaskDetail();
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  private tableDataQust: any = [];
  // private qustClick() {
  //   this.activeName = "question";
  // }
  // 任务进度
  private taskProgressList:any=[]
  private projectTaskProgressList() {
    let pamars: any = {};
    pamars.user_name = UserModule.getUserName;
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    if (parseInt(this.detailData.is_project) === 1) {
      pamars.project_id = this.detailData.id;
    } else {
      pamars.project_id = this.detailData.project_id;
      pamars.project_task_id = this.detailData.id;
    }
    pamars.page = this.page;
    pamars.size = 100;
    getProjectTaskProgressList(pamars)
      .then((res) => {
        if (res.data) {
          this.taskProgressList = res.data.list
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  private imgLarge(item:any) {
    if (parseInt(item.type) === 4) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", item.url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = item.name;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
      return
    }
    let index = 0;
    let imgList: any = [];
    if (parseInt(item.type) === 3) {
      let h: any = {};
      h.media_type = 2;
      h.video_url = item.url;
      imgList.push(h);
    } else if (parseInt(item.type) === 1) {
      imgList.push(item.url);
    }

    let enlargedData = {
      isShow: true,
      imgList: imgList,
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }
  // 待解决问题
  private page = 1;
  private isLoadMoreQuest = false;
  private getQust() {
    let pamars: any = {};
    pamars.user_name = UserModule.getUserName;
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    if (parseInt(this.detailData.is_project) === 1) {
      pamars.project_id = this.detailData.id;
    } else {
      pamars.project_id = this.detailData.project_id;
      pamars.project_task_id = this.detailData.id;
    }
    pamars.page = this.page;
    pamars.size = 100;
    getProjectQuestionList(pamars)
      .then((res) => {
        if (res.data) {
          if (this.page >= res.data.page_count) {
            this.isLoadMoreQuest = false;
          } else {
            this.isLoadMoreQuest = true;
          }
          if (this.page === 1) {
            this.tableDataQust = res.data.list;
          } else {
            this.tableDataQust = this.tableDataQust.concat(res.data.list);
          }
        } else {
          this.isLoadMoreQuest = false;
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.isLoadMoreQuest = false;
      });
  }
  private getQuestionState(row: any) {
    let state = "";
    switch (parseInt(row.state)) {
      case 1:
        state = "待解决";
        break;
      case 7:
        state = "已解决";
        break;
    }

    return state;
  }
  private imgLargeHandle(val: any, index: number, type: number, isqustAdd:number) {
    let arr = [];
    if (type === 2) {
      for (let i = 0; i < val.length; i++) {
        let h: any = {};
        h.media_type = type;
        h.video_url = val[i].url;
        arr.push(h);
      }
    } else {
      if (isqustAdd === 1) {
        for (let i = 0; i < val.length; i++) {
          arr.push((this.qiuniuToken.default_url + val[i].content));
        }
      } else {
        for (let i = 0; i < val.length; i++) {
          arr.push(val[i].url);
        }
      }
    }

    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }
  private staffEnterType = 8;
  private dialogSetStaffVisible = false;
  private selectStaffType: number = 1;
  private selectStaffArray: any = [];

  private managerStaff(val: any) {
    this.editUser(val);
  }
  private closeStaffHandle(val: any) {
    this.dialogSetStaffVisible = val;
  }
  private restUser(val: any) {
    this.selectStaffArray = [];
    if (val === 1) {
      if (this.detailData.user_list) {
        this.detailData.user_list.forEach((element: any) => {
          let manager: any = {};
          manager.id = element.user_id;
          manager.name = element.user_name;
          manager.mobile = element.mobile;
          this.selectStaffArray.push(manager);
        });
      }
      this.staffEnterType = 8;
      this.dialogSetStaffVisible = true;
      this.selectStaffType = 1;
    } else {
      if (this.detailData.relation_user_list) {
        this.detailData.relation_user_list.forEach((element: any) => {
          let manager: any = {};
          manager.id = element.user_id;
          manager.name = element.user_name;
          manager.mobile = element.mobile;
          this.selectStaffArray.push(manager);
        });
      }
      this.dialogSetStaffVisible = true;
      this.staffEnterType = 9;
      this.selectStaffType = 2;
    }
  }
  private editUser(val: any) {
    let userList: any = [];
    val.forEach((element: any) => {
      let manager: any = {};
      manager.id = element.id;
      manager.name = element.name;
      manager.mobile = element.mobile;
      userList.push(manager);
    });
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    if (parseInt(this.detailData.is_project) === 1) {
      pamars.project_id = this.detailData.id;
    } else {
      pamars.project_id = this.detailData.project_id;
      pamars.project_task_id = this.detailData.id;
    }
    if (this.selectStaffType === 1) {
      if (userList && userList.length > 0) {
        pamars.manager_users = JSON.stringify(userList);
      }
    } else {
      if (userList && userList.length > 0) {
        pamars.relation_users = JSON.stringify(userList);
      }
    }
    editUser(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        if (this.projectItem && parseInt(this.projectItem.is_project) === 1) {
          this.getProjectDetail();
        } else if (parseInt(this.projectItem.is_task_collect) === 1) {
          this.getProjectTaskCollectDetail();
        } else {
          this.getProjectTaskDetail();
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
